import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "../../alert.service";
import { StorageService } from "../../storage.service";
import { ReportTypes } from "../../../reports/models/reports";
import { TopCancellationReasonsResponse } from "../../../_models";

@Injectable({
  providedIn: "root",
})
export class OverviewSubscriptionCancellationReasonsService extends DashboardService {
  route = "subscription_dashboard/top_cancellation_reasons";
  protected reportType = ReportTypes.SUBSCRIPTION_RETENTION;
  protected data: BehaviorSubject<TopCancellationReasonsResponse> = new BehaviorSubject<TopCancellationReasonsResponse>(undefined);

  constructor(
    protected http: HttpClient,
    protected alertService: AlertService,
    protected storageService: StorageService
  ) {
    super(http, alertService, storageService);
  }
}
